
import React from "react";
import HeroSection from "@/components/HeroSection";

const OutdoorCoachingHero: React.FC = () => {
  return (
    <HeroSection
      title="Wenn Bewegung das Denken öffnet."
      subtitle="Walk & Talk in der Natur, direkt am Rothsee, 30 Minuten von Nürnberg"
      description="Erlebe Coaching in einer inspirierenden Naturkulisse in Bayern. Der Rothsee im Fränkischen Seenland bietet die perfekte Umgebung, um aus gewohnten Denkmustern auszubrechen und mit frischem Blick auf deine Themen zu schauen."
      backgroundClass="bg-joerg-50"
      imageUrl="/lovable-uploads/1d230a42-fa65-4100-9bc6-7317dec21070.png"
      hideHeroLogo={true}
    />
  );
};

export default OutdoorCoachingHero;
